var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30757 11.9722C5.05763 11.7223 5.05763 11.3171 5.30757 11.0671L8.69504 7.67965L5.30757 4.29218C5.05763 4.04224 5.05763 3.63702 5.30757 3.38708C5.55751 3.13714 5.96273 3.13714 6.21267 3.38708L10.0527 7.2271C10.3026 7.47703 10.3026 7.88226 10.0527 8.1322L6.21267 11.9722C5.96273 12.2222 5.55751 12.2222 5.30757 11.9722Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.f0ae297479e035c05e423fc661984ac1.svg";
export { ForwardRef as ReactComponent };